import React from "react";
import { ToastContainer } from 'react-toastify';

import Routes from "./routes";
import { MenuContextProvider } from "./components/Menu/MenuContext";

import "./App.css";
import 'react-toastify/dist/ReactToastify.min.css';


export default function App() {
    return (
        <MenuContextProvider>
            <Routes />
            <ToastContainer />
        </MenuContextProvider>
    );
};
